import api from "./api";
import {
    appTranslate,
    appSettings as appSettingsRequest,
    changeLocale,
} from "./actions";

import { call, put, race, take, takeLatest } from "@redux-saga/core/effects";
import { request } from "api/apiSaga";
import { loadModules } from "moduleSaga";
import { AnyAction } from "redux-saga";
import {
    APP_INIT,
    APP_LOADED,
    APP_TRANSLATE_SUCCESS,
    LOCALE_REQUEST,
    SETTINGS_FAILED,
    SETTINGS_REQUEST,
    SETTINGS_SUCCESS,
} from "types";
import setCustomHeader from "helpers/setCustomHeader";
import queryString from "query-string";
import { isArray, omit } from "lodash";

interface ITranslate {
    response: {
        data: {
            data: any;
            locale: string;
        };
    };
}

interface IRaceEffect {
    failed?: any;
    success?: any;
}

function* initApp() {
    const uuid = window.location.pathname.match(/\/(.+)\/games/)?.[1];
    const searchParams = window.location.search;
    let paramsObject: any = queryString.parse(searchParams, {
        arrayFormat: "bracket",
        parseNumbers: true,
        parseBooleans: true,
    });

    if (paramsObject?.games) {
        const newGames = (paramsObject.games as any).map((game: string) =>
            queryString.parse(game, {
                arrayFormat: "bracket",
                parseNumbers: true,
                parseBooleans: true,
            })
        );
        paramsObject = {
            ...paramsObject,
            games: newGames,
        };
    }
    if (paramsObject?.activities && !isArray(paramsObject?.activities)) {
        paramsObject = {
            ...paramsObject,
            activities: [],
        };
    }
    if (uuid) {
        setCustomHeader("Restaurant", uuid);
        if (window.location.pathname.includes(`/games/live`)) {
            yield call(
                translate,
                appTranslate({
                    params: { locale: paramsObject.locale || "nb" },
                })
            );
        } else {
            yield call(
                translate,
                appTranslate(
                    paramsObject.locale
                        ? { params: { locale: paramsObject.locale } }
                        : {}
                )
            );
        }
        const translations: ITranslate = yield take(APP_TRANSLATE_SUCCESS);
        if (translations) {
            yield put(appSettingsRequest());
            const raceResult: IRaceEffect = yield race({
                failed: take(SETTINGS_FAILED),
                success: take(SETTINGS_SUCCESS),
            });
            if (raceResult.success) {
                const settings = raceResult.success.response.data;
                yield call(loadModules, {}, settings);
                yield put({
                    type: APP_LOADED,
                    searchParams: omit(paramsObject, "locale"),
                });
            } else {
                yield put({
                    type: APP_LOADED,
                    errorMessage: raceResult.failed.response.statusText,
                });
            }
        }
    }
}

function* translate(action: AnyAction): any {
    const response = yield call(request, api.translate, action);

    if (response.status === 200) {
        (window as any).translate = response.data.data;
        document.documentElement.lang = response.data.locale;
        setCustomHeader("Locale", response.data.locale);
    }
}

function* locale(action: AnyAction): any {
    yield call(translate, changeLocale(action.axiosConfig.config));
    yield call(appSettings, appSettingsRequest());
}

export function* appSettings(action: AnyAction): any {
    return yield call(request, api.settings, action);
}

export const appSagas = [
    takeLatest(APP_INIT, initApp),
    takeLatest(LOCALE_REQUEST, locale),
    takeLatest(SETTINGS_REQUEST, appSettings),
];
